export interface DbPrompt {
  title: string;
  text: string;
  created_at: string;
  updated_at: string;
  id: number;
}

export class Prompt {
  title: string;
  text: string;

  constructor(dbPrompt: DbPrompt) {
    this.title = dbPrompt.title;
    this.text = dbPrompt.text;
  }

}
